import React from 'react';
import PropTypes from 'prop-types';
import css from './style.scss';

// The "We couldn't complete your request" bubble with its Try Again button,
// shared by AI Search and PropStream Intelligence (ATAI-556). Each chat keeps
// its own message row and bot avatar around it; only the bubble is shared.
export default function AIChatErrorCard({ title, body, retry, onRetry }) {
  return (
    <div className={css.chatErrorBubble}>
      <div className={css.chatErrorText}>
        {title && <div className={css.chatErrorTitle}>{title}</div>}
        <div className={css.chatErrorBody}>{body}</div>
      </div>
      {retry && (
        <button type="button" className={css.chatErrorAction} onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
}

AIChatErrorCard.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string.isRequired,
  retry: PropTypes.bool,
  onRetry: PropTypes.func,
};

AIChatErrorCard.defaultProps = {
  title: null,
  retry: false,
  onRetry: undefined,
};
